import { createAction } from '@ngrx/store';

export enum LanguageAssignmentsAction {
    InitLocationAssignments = '[Language Assignments Management] Init',
}

export const LanguageAssignmentsActions = {
    initLanguageAssignments: createAction(LanguageAssignmentsAction.InitLocationAssignments),
};

export const AsyncActions = {
    loadActions: [
    ],
    successActions: [
    ],
    errorActions: [
    ],
};
